module.exports = __webpack_public_path__ + "static/landingbuilder-icerik-e3cefe5c66b9af9722cf79085dee0b35.png";